import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import {
  Calendar as ReactBigCalendar,
  DateLocalizer,
} from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

import dayjsLocalizer from './dayjslocalizer';
import localeData from 'dayjs/plugin/localeData';
import minMax from 'dayjs/plugin/minMax';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isBetween from 'dayjs/plugin/isBetween';
import cn from 'classnames';
import './index.scss';
import { useSelector } from 'react-redux';
import { getUserSelectedLanguage } from 'reducers/users';
import { useTranslation } from 'react-i18next';

dayjs.extend(isBetween);
dayjs.extend(isSameOrBefore);
dayjs.extend(localeData);
dayjs.extend(minMax);
dayjs.extend(localizedFormat);
dayjs.extend(utc);
dayjs.extend(timezone);

const localizer = dayjsLocalizer(dayjs);

const Calendar = ({
  events,
  className,
  typeOfViews,
  steps,
  timeSlotWrapper,
  now = new Date(),
  defaultView,
  timeslots,
  eventWrapper,
  toolBarWrapper,
  formats,
  onRangeChange,
  // date = new Date(),
  onView,
  onNavigate,
}) => {
  const lang = useSelector(state => getUserSelectedLanguage(state));
  const { t } = useTranslation();
  const { components, defaultDate, views } = useMemo(
    () => ({
      // types of custom components that can be created
      // event?: React.ComponentType<EventProps<TEvent>> | undefined;
      // eventWrapper?: React.ComponentType<EventWrapperProps<TEvent>> | undefined;
      // eventContainerWrapper?: React.ComponentType | undefined;
      // dateCellWrapper?: React.ComponentType | undefined;
      // dayColumnWrapper?: React.ComponentType | undefined;
      // timeSlotWrapper?: React.ComponentType | undefined;
      // timeGutterHeader?: React.ComponentType | undefined;
      // timeGutterWrapper?: React.ComponentType | undefined;
      // toolbar?: React.ComponentType<ToolbarProps<TEvent, TResource>> | undefined;
      components: {
        timeSlotWrapper: timeSlotWrapper,
        eventWrapper: eventWrapper,
        toolbar: toolBarWrapper,
      },
      defaultDate: now,
      views: typeOfViews,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [typeOfViews, timeSlotWrapper, eventWrapper, toolBarWrapper],
  );

  return (
    <div className={cn(className)}>
      <ReactBigCalendar
        // date={date}
        dayLayoutAlgorithm={'no-overlap'}
        components={components}
        defaultDate={defaultDate}
        events={events}
        localizer={localizer}
        showMultiDayTimes={true}
        step={steps}
        timeslots={timeslots}
        views={views}
        defaultView={defaultView}
        formats={formats}
        onView={onView}
        onNavigate={onNavigate}
        onRangeChange={onRangeChange} //depending on if next or back button is pressed, it will provide the dates for the next view
        culture={lang}
        messages={{
          date: t('Date'),
          time: t('Time'),
          event: t('Events'),
          allDay: t('All Day'),
          week: t('Week'),
          work_week: t('work_week'),
          day: t('day'),
          month: t('Month'),
          previous: t('<'),
          next: t('>'),
          yesterday: t('yesterday'),
          tomorrow: t('tomorrow'),
          today: t('Today'),
          agenda: t('agenda'),
          noEventsInRange: t('noEventsInRange'),
        }}
      />
    </div>
  );
};

Calendar.propTypes = {
  localizer: PropTypes.instanceOf(DateLocalizer),
  events: PropTypes.array,
  className: PropTypes.string,
  typeOfViews: PropTypes.object,
  steps: PropTypes.number,
  timeSlotWrapper: PropTypes.elementType,
  now: PropTypes.instanceOf(Date),
  defaultView: PropTypes.string,
  timeslots: PropTypes.number,
  eventWrapper: PropTypes.elementType,
  toolBarWrapper: PropTypes.elementType,
  formats: PropTypes.string,
  onRangeChange: PropTypes.func,
  date: PropTypes.instanceOf(Date),
  onView: PropTypes.func,
  onNavigate: PropTypes.func,
};

Calendar.defaultProps = {
  steps: 30,
  typeOfViews: {
    work_week: true,
    month: true,
    week: true,
    day: true,
  },
};
export default Calendar;
